import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_BANNERS_START, POST_BANNERS_ERROR, POST_BANNERS_START, POST_BANNERS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/banners/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_BANNERS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_BANNERS_ERROR, error });
  } finally {
    yield put({ type: GET_BANNERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1)
  }
}

export default function* post_banners() {
  yield takeLatest(POST_BANNERS_START, create);
}